import { hasCapability, type User } from "../base";

export const vendorCredit = {
  read: (user: User) => hasCapability(user, "vendorCredit.read"),
  delete: (user: User) => hasCapability(user, "vendorCredit.delete"),
};
